import CourseSchedulingDetailsScreen from './containers/courseSchedulingDetailsScreen'

export {default as CourseSchedulingDetailsScreenLayout} from './components/courseSchedulingDetailsScreenLayout'

export default CourseSchedulingDetailsScreen
